import {XCloseIcon} from '@/components/ui/icon/Icon'
import {ReactNode} from 'react'
import RHT, {Toast} from 'react-hot-toast'
import {StyledToastContainer} from './style'
import {Button} from '@/components/ui/button/Button'

const renderToast = (content: ReactNode, id: string) => (
    <StyledToastContainer>
        {content}
        <Button variant="ghost" shape="text" onClick={() => RHT.dismiss(id)}>
            <XCloseIcon />
        </Button>
    </StyledToastContainer>
)

type Options = Partial<
    Pick<Toast, 'className' | 'id' | 'style' | 'icon' | 'duration' | 'ariaProps' | 'position' | 'iconTheme'>
>

export const toast = {
    success: (content: ReactNode, options?: Options) => RHT.success(t => renderToast(content, t.id), options),
    error: (content: ReactNode, options?: Options) => RHT.error(t => renderToast(content, t.id), options),
    info: (content: ReactNode, options?: Options) => RHT(t => renderToast(content, t.id), options),
    loading: (content: ReactNode, options?: Options) => RHT.loading(t => renderToast(content, t.id), options),
    dismiss: (id: string) => RHT.dismiss(id)
}
